import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "report";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取称重明细单
    async getWeighingDetail({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingReport/WeighingDetail?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //获取称重明细单----挂单/作废单
    async getCancelWeighingDetail({ commit }, payload) {
      let result = await api.get(
        `/api/TransactionReport/WeighingDetail?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    // 导出报表
    async exportWeighingDetail({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingReport/ExportWeighingDetail?${queryString.stringify(
          payload
        )}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
  },
});

export default moduleName;
